import { useEffect, useState } from 'react';

import { type KebabKeys } from '../types';

import styles from './Offers.module.css';

export interface OffersWidgetProps {
  autohideTerms?: string;
  className: string;
  disableAnalytics?: string;
  geotargeting?: string;
  inheritFontFamily?: string;
  offerLimit?: string;
  sortBy?: string;
  theme?: string;
  variation: string;
  vcId: string;
  visibleOffersCount?: string;
}

export interface OffersWidgetAttributes extends KebabKeys<Omit<OffersWidgetProps, 'className'>> {}

export function OffersWidget({
  DISABLE_OFFER_WIDGETS,
  autohideTerms,
  className,
  disableAnalytics,
  geotargeting,
  inheritFontFamily,
  offerLimit,
  sortBy,
  theme,
  variation,
  vcId,
  visibleOffersCount,
}: OffersWidgetProps & { DISABLE_OFFER_WIDGETS?: boolean }) {
  const attrs: OffersWidgetAttributes = {
    'autohide-terms': autohideTerms,
    'disable-analytics': disableAnalytics,
    geotargeting: geotargeting,
    'inherit-font-family': inheritFontFamily,
    'offer-limit': offerLimit,
    'sort-by': sortBy,
    theme: theme,
    variation,
    'vc-id': vcId,
    'visible-offers-count': visibleOffersCount,
  };

  const [showWidget, setShowWidget] = useState(false);

  useEffect(() => {
    setShowWidget(true);
  }, []);

  if (DISABLE_OFFER_WIDGETS) {
    return null;
  }

  return (
    <div className={styles[className]} data-testid="offers-widget-div">
      {showWidget && <oc-offers-widget {...attrs} />}
    </div>
  );
}
